import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isEditAccess)?_c(VBtn,_vm._g(_vm._b({attrs:{"icon":"","small":""}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_c(VIcon,{attrs:{"small":""}},[_vm._v("mdi-lead-pencil")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }